import { QueryFunctionContext } from '@tanstack/react-query'
import { GET, PUT } from '../../../redux/middleware/types'
import backendRequest from '../../../services/api/backendRequest'
import companyInformationEndpoints from '../api/companyInformationEndpoints'
import companyInformationQueryKeys from '../queries/companyInformationQueryKeys'
import { CompanyInformationData } from '../types'

export const getCompanyInformation = async ({
  queryKey: [{ companyId }],
  signal
}: QueryFunctionContext<
  ReturnType<(typeof companyInformationQueryKeys)['detail']>
>): Promise<CompanyInformationData> => {
  return backendRequest<CompanyInformationData>({
    method: GET,
    url: companyInformationEndpoints.detail(companyId!),
    signal
  })
}

export const updateCompanyInformation = async (
  stakeholders: CompanyInformationData['stakeholders'],
  companyId: string
): Promise<CompanyInformationData> => {
  return backendRequest<CompanyInformationData>({
    method: PUT,
    url: companyInformationEndpoints.stakeholders(companyId),
    data: stakeholders
  })
}
